import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Row, Col } from 'pui-react-grids'
import RaisedButton from 'material-ui/RaisedButton'
import Paper from 'material-ui/Paper'
import Delete from 'material-ui/svg-icons/action/delete'
import Spinner from '../common/Spinner'
import { deleteAccount, clearDeleteAccountError } from '../actions'

import { themeColors } from '../styles/theme'
const styles = {
  mainCol: {
    margin: 0,
    paddingBottom: '40px',
  },
  containerStyle: {
    padding: 10,
  },
  title: {
    color: themeColors.positive,
    textTransform: 'uppercase',
  },
  titleIcon: {
    fill: themeColors.positive,
    position: 'relative',
    top: 5,
    marginRight: 5,
  },
  buttonLeft: {
    marginLeft: 10,
  },
  buttonRight: {
    marginLeft: 'auto',
    marginRight: 10,
  },
  btnContainer: {
    paddingTop: 30,
    marginBottom: 10,
    display: 'flex',
  },
  textContainer: {
    padding: 10,
  },
  errorMessage: {
    padding: 10,
    color: themeColors.secondary,
    backgroundColor: themeColors.lightBackground,
    borderRadius: 4,
    margin: 10,
  },
}

class DeleteAccount extends PureComponent {
  componentWillUnmount() {
    this.props.clearDeleteAccountError()
  }

  render() {
    const { deleting, error, deleteAccount } = this.props
    return (
      <div className="padding" style={{ minHeight: '100vh' }}>
        <Row style={{ marginLeft: 0, marginRight: 0 }}>
          <Col md={3} />
          <Col md={18} style={styles.mainCol}>
            <Paper style={styles.containerStyle}>
              <div>
                <h3 style={styles.title}>
                  <Delete style={styles.titleIcon} />Cancella Account
                </h3>
              </div>

              <p style={styles.textContainer}>
                Sei sicuro di volore cancellare il tuo account? Questa operazione non è reversibile.
              </p>

              {error &&
                <p style={styles.errorMessage}>
                  Ops, si è verificato un errore durante la cancellazione account.
                </p>}

              <div>
                {deleting && <Spinner centered />}
                {!deleting &&
                  <div style={styles.btnContainer}>
                    <RaisedButton
                      disabled={false}
                      label="Annulla"
                      containerElement={<Link to="/profile" />}
                      style={styles.buttonLeft}
                      backgroundColor={themeColors.lightblack}
                      labelColor={themeColors.white}
                    />
                    <RaisedButton
                      disabled={false}
                      type="submit"
                      label="Cancella Account"
                      backgroundColor={themeColors.evilred}
                      labelColor={'#fff'}
                      style={styles.buttonRight}
                      onClick={deleteAccount}
                    />
                  </div>}
              </div>
            </Paper>
          </Col>
          <Col md={3} />
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  deleting: state.auth.deleting,
  error: state.auth.deleteAccountError,
})

export default connect(mapStateToProps, {
  deleteAccount,
  clearDeleteAccountError,
})(DeleteAccount)



// WEBPACK FOOTER //
// ./src/pages/DeleteAccount.js